// extracted by mini-css-extract-plugin
module.exports = {"authorSeries":"AuthorsDetail_authorSeries__4pVbI","authorSeries_first":"AuthorsDetail_authorSeries_first__o9wR8","authorSeries__link":"AuthorsDetail_authorSeries__link__M5_B8"};